import { DispatchListDetailsRes } from '@zonofi/zono-money-store';

interface TermsAndDeliveryProps {
  dispatchNoteDetails: DispatchListDetailsRes;
}

export const TermsAndDelivery = (props: TermsAndDeliveryProps) => {
  const { dispatchNoteDetails } = props;
  return (
    <div className="dispatch-note-detail-box font-regular">
      <span className="dispatch-note-details-box-heading font-semibold">
        Terms of Delivery
      </span>
      <div className="disaptch-note-detail-box-content"></div>
      <span className="dispatch-note-detail-box-content-text-label">
        {dispatchNoteDetails?.termsOfDelivery || 'N/A'}
      </span>
    </div>
  );
};
